import React, { useState, useRef, useEffect } from 'react';
import { Textarea } from '../../../components/ui/textarea';

interface MemoryBlockEditorProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

export const MemoryBlockEditor: React.FC<MemoryBlockEditorProps> = ({
  value,
  onChange,
  placeholder = 'Add your personal context here...\n\nFor example:\n• I work as a product manager at a tech company\n• I prefer concise summaries\n• Use British English spelling',
}) => {
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  const [localValue, setLocalValue] = useState(value);

  // Sync with external value changes
  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newValue = e.target.value;
    setLocalValue(newValue);
    onChange(newValue);
  };

  return (
    <div className="w-full">
      <Textarea
        ref={textareaRef}
        value={localValue}
        onChange={handleChange}
        placeholder={placeholder}
        className="min-h-[300px] resize-none font-sans text-sm leading-relaxed"
      />
    </div>
  );
};
